import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'src/hooks';
import { pageNotFoundPageRoute } from 'src/routes/route-list';

export const SuperadminPageBlocker = () => {
  const { user } = useAuth();

  if (!user || user.role !== 'ADMIN') {
    return <Navigate to={pageNotFoundPageRoute} />;
  }

  return <Outlet />;
};
